import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const ImageInfoBoxWrapper = styled(Box)`
    align-items: stretch;
    overflow: hidden;
    border-radius: 16px 16px 8px 8px;
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    > div:first-child {
        width: 100%;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    @media ${respondAbove.xl} {
        width: 570px;
        border-radius: 8px;
        > div:first-child {
            width: 170px;
            img {
                object-position: center;
                border-radius: 8px 0 0 8px;
            }
        }
        > div:last-child {
            max-width: 352px;
        }
    }
`
